<template>
    <div class="assembleMain_info">
        <!-- 试卷标题 -->
        <div class="assembleMain_top_title" v-if="assemblyData.options.struct_title||assemblyData.options.struct_subtitle">
            <h2 v-if="assemblyData.options.struct_title&&mainTitleDisabled" @click="editMainTitle" :class="{readonly:!this.title_edit.title}">{{mainTitle}}</h2>
            <input v-if="assemblyData.options.struct_title&&!mainTitleDisabled" ref="mainTitle" type="text" v-model.trim="mainTitle" @blur="changeMainTitle" @keydown.13="$refs.mainTitle.blur()" maxlength="100" />
            <br>
            <h3 v-if="assemblyData.options.struct_subtitle&&subtitleDisabled" @click="editSubTitle" :class="{readonly:!this.title_edit.title}">{{subTitle}}</h3>
            <input v-if="assemblyData.options.struct_subtitle&&!subtitleDisabled" ref="subTitle" type="text" v-model.trim="subTitle" @blur="changeSubTitle" @keydown.13="$refs.subTitle.blur()" maxlength="30"  />
            <!-- <h2 contenteditable="true">主标题</h2>
            <h3 contenteditable="true">副标题</h3> -->
        </div>
        <!-- 考试填写 -->
        <div class="assembleMain_top_info" v-if="assemblyData.options.struct_student">
            <label>姓名：</label>
            <i>_____________</i>
            <label>班级：</label>
            <i>_____________</i>
            <label>学号：</label>
            <i>_____________</i>
        </div>
        <!-- 注意事项 -->
        <div class="assembleMain_top_note" v-if="assemblyData.options.struct_notice">
            <p>注意事项：</p>
            <pre @click="editNotice" v-if="noticeDisabled">{{notice}}</pre>
            <textarea v-model.trim="notice" v-if="!noticeDisabled" ref="notice" @blur="changeNotice" maxlength="200"></textarea>
        </div>
    </div>
</template>
<script>
import $store from '../store'
export default {
    props:['department_name','subject_name','title_edit'],
    data () {
        return {
            mainTitleDisabled:true,//主标题
            subtitleDisabled:true,//副标题
            noticeDisabled:true,//注意事项
        }
    },
    methods: {
        editMainTitle(){//点击编辑主标题
            if(!this.title_edit.title) return
            this.mainTitleDisabled = false
            this.$nextTick(()=>{
                this.$refs.mainTitle.focus()
            })
        },
        changeMainTitle(){//保存主标题
            if(this.mainTitle == ''){
                this.mainTitle = null
                this.$refs.mainTitle.focus()
                return
            }
            this.mainTitleDisabled = true
        },
        editSubTitle(){//点击编辑副标题
            if(!this.title_edit.subtitle) return
            this.subtitleDisabled = false
            this.$nextTick(()=>{
                this.$refs.subTitle.focus()
            })
        },
        changeSubTitle(){//保存副标题
            if(this.subTitle == ''){
                this.subTitle = null
                this.$refs.subTitle.focus()
                return
            }
            this.subtitleDisabled = true
        },
        editNotice(){//编辑注意事项
            this.noticeDisabled = false
            this.$nextTick(()=>{
                this.$refs.notice.focus()
            })
        },
        changeNotice(){//保存注意事项
            if(this.notice == ''){
                this.notice = '请填写注意事项'
                this.$refs.notice.focus()
                return
            }
            this.noticeDisabled = true
        }  
    },
    computed: {
        assemblyData(){
            return $store.state.assemblyData
        },
        mainTitle:{//主标题
            set(val){
                $store.commit('RENEWASSEMBLESTORE',{name:'name',value:val})
            },
            get(){
                if(this.assemblyData.name != null){
                    return this.assemblyData.name
                }else{
                    let date = new Date()
                    let year = date.getFullYear()
                    let month = date.getMonth()+1
                    let day = date.getDate()
                    let paperName = year + '年' + month + '月' + day + '日'+ this.department_name+this.subject_name +'试卷'
                    $store.commit('RENEWASSEMBLESTORE',{name:'name',value:paperName})
                    return paperName
                }
            }
        },
        subTitle:{//副标题
            set(val){
                $store.commit('RENEWASSEMBLESTORE',{name:'sub_title',value:val})
            },
            get(){
                if(this.assemblyData.sub_title != null){
                    return this.assemblyData.sub_title
                }else{
                    let sub_title = this.subject_name+'考试'
                    $store.commit('RENEWASSEMBLESTORE',{name:'sub_title',value:sub_title})
                    return sub_title
                }
            }
        },
        notice:{//注意事项
            set(val){
                $store.commit('RENEWASSEMBLESTORE',{name:'notice',value:val})
            },
            get(){
                return this.assemblyData.notice
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// packages/question-assembly/src/mainInfo.vue